// extracted by mini-css-extract-plugin
module.exports = {"checkoutSummary":"CheckoutSummary_checkoutSummary__JQdvp"};